// extracted by mini-css-extract-plugin
export var numpadContainer = "_ne-1";
export var phoneButton = "_ne-0";